import { cva as e } from "class-variance-authority";
// src/design/menu/style.ts
var t = e("inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium transition-colors duration-normal disabled:opacity-50 disabled:cursor-not-allowed focus-ring", {
	variants: {
		variant: {
			default: "bg-card border border-border text-foreground hover:bg-muted hover:border-primary data-[state=open]:bg-muted data-[state=open]:border-primary",
			outline: "bg-transparent border border-border text-foreground hover:bg-accent hover:border-primary data-[state=open]:bg-accent data-[state=open]:border-primary",
			ghost: "bg-transparent text-foreground hover:bg-muted",
			icon: "bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground rounded-md"
		},
		size: {
			sm: "h-8 px-3 text-xs",
			md: "h-10 px-4 text-sm",
			lg: "h-12 px-6 text-base",
			icon: "h-8 w-8 p-0"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "sm"
	}
}), n = e("z-floating bg-menu-background rounded-lg shadow-floating border border-border p-1 focus:ring-0 focus:outline-hidden animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", {
	variants: { width: {
		auto: "min-w-[12rem]",
		sm: "w-48",
		md: "w-64",
		lg: "w-80",
		full: "w-full"
	} },
	defaultVariants: { width: "auto" }
}), r = e("relative flex items-center gap-3 px-3 py-2 rounded-md text-sm outline-hidden cursor-pointer transition-colors duration-fast data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed data-[disabled]:hover:bg-transparent", {
	variants: { variant: {
		default: "text-foreground hover:bg-muted data-[highlighted]:bg-muted",
		danger: "text-destructive hover:bg-destructive/10 data-[highlighted]:bg-destructive/10"
	} },
	defaultVariants: { variant: "default" }
}), i = e("my-1 h-px bg-border border-border"), a = e("px-3 py-2 text-xs font-semibold text-muted-foreground", {
	variants: { casing: {
		upper: "uppercase tracking-wider",
		sentence: "normal-case tracking-normal"
	} },
	defaultVariants: { casing: "upper" }
}), o = e(""), s = e("inline-flex items-center justify-center px-4 py-2 rounded-lg bg-card border border-border text-sm font-medium text-foreground cursor-context-menu transition-colors duration-normal"), c = e("relative !flex !flex-row items-center gap-3 px-3 py-2 rounded-md text-sm outline-hidden cursor-pointer transition-colors duration-fast text-foreground hover:bg-muted data-[highlighted]:bg-muted data-[checked]:bg-accent/50 data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed data-[disabled]:hover:bg-transparent"), l = e("relative !flex !flex-row items-center gap-3 px-3 py-2 rounded-md text-sm outline-hidden cursor-pointer transition-colors duration-fast text-foreground hover:bg-muted data-[highlighted]:bg-muted data-[checked]:bg-accent/50 data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed data-[disabled]:hover:bg-transparent"), u = e("flex items-center justify-center w-4 h-4 min-w-[1rem] min-h-[1rem] shrink-0 text-primary [&>svg]:w-full [&>svg]:h-full opacity-0 data-[state=checked]:opacity-100 transition-opacity duration-fast"), d = e("flex-1 text-sm text-foreground leading-tight");
export { c as menuCheckboxItemStyles, n as menuContentStyles, s as menuContextTriggerStyles, o as menuGroupStyles, u as menuItemIndicatorStyles, r as menuItemStyles, d as menuItemTextStyles, a as menuLabelStyles, l as menuRadioItemStyles, i as menuSeparatorStyles, t as menuTriggerStyles };

//# sourceMappingURL=style.js.map